import gql from 'graphql-tag'

export default gql`
	query listAdditions {
		cashAssist {
			listProductAdditions {
				id
				name
				variants
			}
		}
	}
`
